import { defineComponent as _defineComponent } from 'vue'
import { store } from "@/store";
import { computed } from "vue";
import { SiteMode } from "./site-mode";


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckoutProgress',
  props: {
    activeIndex: null,
    siteMode: null
  },
  setup(__props: any) {

const props = __props as {
   activeIndex?: number, siteMode: SiteMode
}

const b2CSteps = [
    {
        label: "Pages.Checkout.Progress.Step1",
        complete: false,
        current: false,
        url: undefined
    },
    {
        label: "Pages.Checkout.Progress.Step2",
        complete: false,
        current: false,
        url: undefined
    },
    {
        label: "Pages.Checkout.Progress.Step3",
        complete: false,
        current: false,
        url: undefined
    },
    {
        label: "Pages.Checkout.Progress.Step4",
        complete: false,
        current: false,
        url: undefined
    }
];

const b2BSteps = [
    {
        label: "Pages.CheckoutB2B.Progress.Step1",
        complete: false,
        current: false,
        url: undefined
    },
    {
        label: "Pages.CheckoutB2B.Progress.Step2",
        complete: false,
        current: false,
        url: undefined
    }
];

const posSteps = [
    {
        label: "Pages.CheckoutPOS.Progress.Step1",
        complete: false,
        current: false,
        url: undefined
    },
    {
        label: "Pages.CheckoutPOS.Progress.Step2",
        complete: false,
        current: false,
        url: undefined
    },
    {
        label: "Pages.CheckoutPOS.Progress.Step3",
        complete: false,
        current: false,
        url: undefined
    }
];

let steps : any[];



if (props.siteMode === SiteMode.B2C) {
    steps = b2CSteps;
}

if (props.siteMode === SiteMode.B2B) {
    steps = b2BSteps;
}

if (props.siteMode === SiteMode.POS) {
    steps = posSteps;
}
const basketUrl = computed<string>(() => store.getters["app/basketUrl"]);
const checkoutUrl = computed<string>(() => store.getters["app/checkoutUrl"]);

steps.forEach((step, index) => {
    const isOnConfirmationStep = props.activeIndex === steps.length - 1;
    if (!isOnConfirmationStep) {
        if (index === 0) {
            step.url = basketUrl.value;
        } else if (props.activeIndex > 1 && index === 1) {
            step.url = checkoutUrl.value;
        }
    }
    if (index < props.activeIndex) {
        step.complete = true;
    }
    if (index === props.activeIndex) {
        step.current = true;
    }
});


return { __sfc: true,b2CSteps, b2BSteps, posSteps, steps, props, basketUrl, checkoutUrl }
}

})